import { startApp } from "./react";

(async () => {
    startApp("app");
})();
